import styled from "styled-components";
import ErrorIcon from "../Images/icon_toast_error.svg";
import SuccessIcon from "../Images/icon_toast_success.svg";

// react-toastify 사용에따른 closeToast 에러 해결을 위한 컴포넌트
const ToastMessageWrapper = ({ message, type }) => {
  return (
    <ToastMessage>
      <img
        src={type === "success" ? SuccessIcon : ErrorIcon}
        alt={type === "success" ? "성공" : "실패"}
        style={{ width: "24px", height: "24px" }}
      />
      <span>{message}</span>
    </ToastMessage>
  );
};

const ToastMessage = styled.div`
  width: 560px;
  height: 60px;
  background-color: #000000;
  border-radius: 10px;
  display: flex;
  align-items: center;
  color: #ffffff;
  font-family: "notoSans-medium";
  font-size: 16px;
  img {
    margin-left: 20px;
    margin-right: 8px;
  }
`;

export default ToastMessageWrapper;
